import { render, staticRenderFns } from "./BlocoDeCodigo.vue?vue&type=template&id=e19928bc&scoped=true&"
import script from "./BlocoDeCodigo.vue?vue&type=script&lang=ts&"
export * from "./BlocoDeCodigo.vue?vue&type=script&lang=ts&"
import style0 from "./BlocoDeCodigo.vue?vue&type=style&index=0&id=e19928bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19928bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VIcon,VSheet})
